import { PasswordField } from "@/components/index/PasswordField";
import { Button } from "@/components/ui/Button";
import {
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/Dialog";
import { useAppContext } from "@/context/AppContext";
import { useLanguage } from "@/context/LanguageContext";
import { useMenuItemsContext } from "@/context/MenuItemsContext";

export function ChangePassword() {
  const { language } = useLanguage();
  const copy = {
    cs: {
      title: "Změnit heslo",
      description: "Upravte své údaje níže.",
      oldPassword: "Původní heslo",
      newPassword: "Nové heslo",
      repeatPassword: "Nové heslo znovu",
      cancelChanges: "Zrušit změny",
      saveChanges: "Uložit změny",
    },
    en: {
      title: "Change password",
      description: "Edit your details below.",
      oldPassword: "Current password",
      newPassword: "New password",
      repeatPassword: "Repeat new password",
      cancelChanges: "Cancel changes",
      saveChanges: "Save changes",
    },
  }[language];
  const fields = [
    {
      id: "oldPassword",
      label: copy.oldPassword,
      key: "oldPassword",
      autoComplete: "current-password",
    },
    {
      id: "password",
      label: copy.newPassword,
      key: "newPassword",
      autoComplete: "new-password",
    },
    {
      id: "passwordRepeat",
      label: copy.repeatPassword,
      key: "passwordRepeat",
      autoComplete: "new-password",
    },
  ] as const;
  const { isLoading, formData, setFormData, errorMessage } = useAppContext();
  const { handleDiscardChanges, resetPassword } = useMenuItemsContext();

  return (
    <DialogContent className="sm:max-w-[425px]">
      <form
        onSubmit={(e) => {
          e.preventDefault();
          resetPassword();
        }}
        className="space-y-4"
      >
        <DialogHeader>
          <DialogTitle>{copy.title}</DialogTitle>
          <DialogDescription>{copy.description}</DialogDescription>
        </DialogHeader>

        <div className="grid gap-3 py-4">
          {fields.map(({ id, label, key, autoComplete }) => (
            <PasswordField
              key={id}
              id={id}
              name={id}
              label={label}
              value={formData[key] || ""}
              onChange={(value) => setFormData({ ...formData, [key]: value })}
              autoComplete={autoComplete}
            />
          ))}

          {errorMessage && (
            <div className="mt-2 font-semibold bg-red-50 p-2 rounded-md border border-red-200 text-center">
              <p className="text-sm text-red-500">{errorMessage}</p>
            </div>
          )}
        </div>

        <DialogFooter className="flex flex-row justify-end items-center gap-3">
          <Button
            type="button"
            variant="outline"
            onClick={handleDiscardChanges}
          >
            {copy.cancelChanges}
          </Button>
          <Button type="submit" disabled={isLoading} variant="default">
            {isLoading ? (
              <span className="dots">
                <span className="dot" />
                <span className="dot" />
                <span className="dot" />
              </span>
            ) : (
              copy.saveChanges
            )}
          </Button>
        </DialogFooter>
      </form>
    </DialogContent>
  );
}
